import _ from 'lodash';
import {
  FETCH_PROFOMAS,
  PUSH_PROFOMAS,
  REMOVE_PROFOMAS,
  UPDATE_PROFOMAS,
  UPDATE_MODE,
  UPDATE_ACTIVE_ID } from '../actions/actions-profomas';

const INITIAL_STATE = {
  profomas: [],
  mode: 'index',
  activeId: '',
  activeProfomas:{}
}


export default function(state = INITIAL_STATE, action){
  switch(action.type){
    case FETCH_PROFOMAS:
      return {
        ...state,
        profomas:action.payload,
      }
    case PUSH_PROFOMAS:
      return {
        ...state,
        profomas:[action.payload, ...state.profomas],
      }
    case REMOVE_PROFOMAS:
      return {
        ...state,
        profomas : [...state.profomas.filter( (item) => item._id !== action.payload._id)]
      }
    case UPDATE_PROFOMAS:
      let index =  _.findIndex(state.profomas, { '_id': action.payload._id })
      state.profomas.splice(index, 1, action.payload)
      return {
        ...state,
        profomas : state.profomas
      }
    case UPDATE_MODE:
      return {
        ...state,
        mode : action.payload,
        activeId:''
      }
    case UPDATE_ACTIVE_ID:
      return {
        ...state,
        mode : action.mode,
        activeId:action.id,
        activeProfomas: _.pick(_.find(state.profomas, { '_id': action.id }), ['chargesId', 'description', 'amount', 'status', '_id'])
      }
    default:
      return state

  }
}